import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import "animate.css/animate.css";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import './styles/TagDatetimeFields.css';


const TagDatetimeField = (props) => {
  const [value, setValue] = useState(props.value ? dayjs(props.value) : null);
  const tipText =  props.prompt?props.prompt:'';
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;
  const isAlwaysOn = props.isAlwaysOn || false;

  useEffect(() => {
    setValue(props.value ? dayjs(props.value) : null);
  },[props.value]);

  const isEmpty = !value || (typeof value.isValid === 'function' && !value.isValid());
  const error =
    (validationCase === 'case_4' && props.required && isAlwaysOn && isEmpty) ||
    (validationCase === 'case_2' && props.required && isTagChecked && isEmpty);
  const helperText = error
    ? (validationCase === 'case_4' ? 'This field is required' : 'This field is required if active')
    : '';

  const handleChange = (newValue) => {
    // Send as local wall-clock YYYY-MM-DD HH:mm string so the round-trip through
    // the backend (which echoes datetimes without a TZ marker) doesn't shift by
    // the user's offset. Matches the format used by other date/time pickers.
    props.onChange({
      name: props.param,
      value: newValue && newValue.isValid?.() ? newValue.format("YYYY-MM-DD HH:mm") : "",
    });
    setValue(newValue);
  };

  return (
    <Grid container className="tag-datetime-field-container">
      <Grid item xs={12} sm={12} className="datetime-picker-item">
        <Tooltip title={tipText} placement="top" arrow>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              fullWidth
              size='small'
              label={props.label}
              value={value}
              onChange={handleChange}
              ampm={false}
              format="YYYY-MM-DD HH:mm"
              className="datetime-picker"
              slotProps={{ textField: { error, helperText } }}
            />
          </LocalizationProvider>
        </Tooltip>
      </Grid>
    </Grid>
  );

};

export default TagDatetimeField;
